exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n  padding-top: 6px;\n  padding-bottom: 6px; }\n\n.itm {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.even {\n  background: #ddd; }\n\n.del-row {\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.itm-cont {\n  height: 30px; }\n\n.btn-busy {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background: #e1f1f6 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/company/notifications/site-notifications/site-notifications-item/site-notifications-item.component.scss
// module id = ../../../../../src/app/views/site-admin/company/notifications/site-notifications/site-notifications-item/site-notifications-item.component.scss
// module chunks = main